import { render, staticRenderFns } from "./u-file-input-outlined-rounded.vue?vue&type=template&id=55a3c7f9&scoped=true&"
import script from "./u-file-input-outlined-rounded.vue?vue&type=script&lang=js&"
export * from "./u-file-input-outlined-rounded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a3c7f9",
  null
  
)

export default component.exports